//vue实例单独提取到了app文件中
import app from '@/utils/app';
import router from './router';
import { createPinia } from 'pinia';

import './style.css';
import 'amfe-flexible';
import vant from 'vant';
import VueI18n from '@/language';
import './utils/vconsole';
import './utils/native';
import Common from '@/utils/common';

import '@/utils/sentry';
import { preloadElementImage } from '@/utils/preloadElementImage';
preloadElementImage();

app.config.globalProperties.$common = Common;

app.use(createPinia());
app.use(router);
app.use(VueI18n);
app.use(vant);

app.mount('#app');
